import React, { useEffect } from 'react';
import { BackHandler, StyleSheet, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import { Button, Icon } from '../../../components';
import theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { musicSourceSelected, spotifyOnBoardingClosed } from './actions';
import { useSpotifyOnboardingConfig } from './useSpotifyOnboardingConfig';
import Orientation from 'react-native-orientation-locker';
import { musicPlatform } from '../../../../../gym-core/lib';


interface IProps {
  t: (key: string, options?: any) => string;
  startMusic: () => void;
  closeOnBoarding: () => void;
}

const MusicSpotifyOnBoardingComponent = ({ t, closeOnBoarding, startMusic}) => {
  useEffect(()=>{
    Orientation.lockToPortrait()
    return () =>{
      Orientation.unlockAllOrientations()
    }
  },[])
  useEffect(() => {
    const backPressHandler = () => {
      closeOnBoarding();
      return true;
    };

    const backHandler = BackHandler.addEventListener('hardwareBackPress', backPressHandler);

    return () => backHandler.remove();
  }, []);

  const { config, currentScreen } = useSpotifyOnboardingConfig(t, startMusic);
  const configForCurrentScreen = config[currentScreen];

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.closeIconContainer} onPress={closeOnBoarding}>
        <Icon name='md-close' color={theme.GREY} size={defaultScale(35)} />
      </TouchableOpacity>
      <View style={styles.imageContainer}>{configForCurrentScreen.image}</View>
      <View style={styles.buttonAndTextContainer}>
        <View style={styles.textContainer}>
          {configForCurrentScreen.heading}
          {configForCurrentScreen.description &&
            configForCurrentScreen.description}
        </View>
        <View style={styles.buttonContainer}>
          {configForCurrentScreen.buttons.map((button) => {
            return (
              <Button
                title={button.text}
                overrideFontStyles={styles.buttonText}
                containerStyle={styles.button}
                onPress={button.onPress}
              />
            );
          })}
        </View>
      </View>
    </View>
  );
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    closeOnBoarding: () => dispatch(spotifyOnBoardingClosed()),
    startMusic: () => dispatch((musicSourceSelected(musicPlatform.Spotify))),
  };
};

export const MusicSpotifyOnBoarding = connect(
  null,
  mapDispatchToProps,
)(MusicSpotifyOnBoardingComponent);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.WHITE,
  },
  buttonAndTextContainer: {
    height: '33%',
    flexDirection: 'column',
  },
  imageContainer: {
    flex: 1,
  },
  buttonContainer: {
    paddingHorizontal: defaultScale(12),
    paddingBottom: defaultScale(12),
  },
  button: {
    marginTop: defaultScale(9),
    height: defaultScale(48),
  },
  buttonText: {
    fontWeight: '700',
    color: theme.WHITE,
  },
  textContainer: {
    flex: 1,
    paddingHorizontal: defaultScale(20),
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIconContainer: {
    position: 'absolute',
    top: 0,
    right: 10,
    zIndex: 90,
  },
});
